/**
 * The Test Instances text filter: case-insensitive `includes` on the
 * instance title, plus the testcase id (people paste ids constantly —
 * "#tc-" prefixed pastes still match). Pending
 * rows match on their id-derived stand-in title — results can grow while
 * hydration is still streaming titles in.
 */
export function instanceMatches(row, id, query) {
  var _row$title;
  var q = query.trim().toLowerCase();
  if (!q) return true;
  var title = ((_row$title = row === null || row === void 0 ? void 0 : row.title) !== null && _row$title !== void 0 ? _row$title : id).toLowerCase();
  if (title.includes(q)) return true;
  var tc = row === null || row === void 0 ? void 0 : row.testcaseId;
  if (tc) {
    var tcLower = tc.toLowerCase();
    if (tcLower.includes(q) || "#tc-".concat(tcLower).includes(q)) return true;
  }
  return false;
}